// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"188":"33deda78","583":"a306c59b","845":"0dc8666e","958":"dc0bf68f"}[chunkId] + ".css";
};